export default "<body dir=\"rtl\">\r\n  <div class=\"containerApp\">\r\n    <router-outlet></router-outlet>\r\n  </div>\r\n</body>\r\n"